import React from "react";
import { connect } from "react-redux";
import { change, formValueSelector } from "redux-form";
import { compose, withProps, lifecycle } from "recompose";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker
} from "react-google-maps";
import getSafe from './pkadmin/util'


const formSelector = formValueSelector("record-form");

const MyMapComponent = compose(
  withProps({
    googleMapURL:
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyCYSleVFeEf3RR8NlBy2_PzHECzPFFdEP0&libraries=geometry,drawing,places",
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `400px` }} />,
    mapElement: <div style={{ height: `100%` }} />
  }),
  lifecycle({
    componentWillMount() {
      const refs = {};

      this.setState({
        onMarkerMounted: ref => {
          refs.marker = ref;
        },

        onPositionChanged: () => {
          const position = refs.marker.getPosition();
          console.log(position.toString());
          this.props.onMakerPositionChanged(position);
        }
      });
    }
  }),
  withScriptjs,
  withGoogleMap
)(props => {
  console.log("POSITION:", props.position)
  const lati = getSafe(() => props.position.lat, 53.3423)
  const longi = getSafe(() => props.position.lng, -6.25)

  return (
    <GoogleMap defaultZoom={8} defaultCenter={{ lat: lati, lng: longi}}>
      {props.isMarkerShown && (
        <Marker
          position={props.position}
          draggable={true}
          ref={props.onMarkerMounted}
          onPositionChanged={props.onPositionChanged}
        />
      )}
    </GoogleMap>
  );
});

class MyParentComponentWrapper extends React.Component {

  static defaultProps = {
    position: {lat: 53.3423, lng: -6.25}
  }

  constructor(props) {
    super(props);
    this.state = {
      isMarkerShown: false
    };

    this.onMakerPositionChanged = this.onMakerPositionChanged.bind(this);
  }

  onMakerPositionChanged(position) {
    this.props.dispatch(change("record-form", "lat", position.lat()));
    this.props.dispatch(change("record-form", "lng", position.lng()));
  }

  render() {
    return (
      <div>
        <MyMapComponent
          isMarkerShown={true}
          onMakerPositionChanged={this.onMakerPositionChanged}
          position={this.props.position}
        />
        <div />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  position: {
    lat: parseFloat(formSelector(state, "lat")),
    lng: parseFloat(formSelector(state, "lng"))
  }
});

export default connect(mapStateToProps)(MyParentComponentWrapper);
